module.exports = __webpack_public_path__ + "static/media/217.94b243b8.wav";